import { Toaster as HotToaster } from 'react-hot-toast';
import { CheckCircle, XCircle, AlertTriangle, Info } from 'lucide-react';

const icons = {
  success: <CheckCircle className="w-4 h-4 text-status-normal" />,
  error: <XCircle className="w-4 h-4 text-status-critical" />,
  warning: <AlertTriangle className="w-4 h-4 text-status-warning" />,
  info: <Info className="w-4 h-4 text-accent" />,
};

interface ToastContainerProps {
  position?: 'top-right' | 'bottom-right' | 'top-left' | 'bottom-left' | 'top-center' | 'bottom-center';
}

export function ToastContainer({ position = 'top-right' }: ToastContainerProps) {
  return (
    // @ts-expect-error react-hot-toast exposes a compatible runtime component with incomplete local typings.
    <HotToaster
      position={position}
      toastOptions={{
        duration: 4000,
        style: {
          background: '#1F2937',
          color: '#F3F4F6',
          borderRadius: '2px',
          fontSize: '13px',
          border: '1px solid #374151',
          fontFamily: "'Inter', sans-serif",
          padding: '12px 16px',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          minWidth: '280px',
        },
        success: { icon: icons.success },
        error: { icon: icons.error },
        warning: { icon: icons.warning },
        info: { icon: icons.info },
      } as any}
    />
  );
}
